import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import {
  GrupoModificadorDTO,
  GrupoModificadorConsultaDTO,
  OpcaoModificadorDTO,
  OpcaoModificadorConsultaDTO,
  ReordenarDTO,
} from '../../models/cardapio-minishop/cardapio-minishop.model';

@Injectable({
  providedIn: 'root',
})
export class CardapioMinishopModificadorService {

  private readonly grupoBasePath = '/api/grupo-modificador';
  private readonly opcaoBasePath = '/api/opcao-modificador';

  constructor(private apiService: ApiService) {}

  // --- Grupos de Modificador ---

  // Lista todos os grupos da empresa (sem produtoId - desacoplado)
  listarGrupos(): Observable<GrupoModificadorConsultaDTO[]> {
    return this.apiService.read<GrupoModificadorConsultaDTO[]>(this.grupoBasePath);
  }

  buscarGrupoPorId(id: number): Observable<GrupoModificadorConsultaDTO> {
    return this.apiService.read<GrupoModificadorConsultaDTO>(
      `${this.grupoBasePath}/${id}`
    );
  }

  criarGrupo(data: GrupoModificadorDTO): Observable<GrupoModificadorConsultaDTO> {
    return this.apiService.create<GrupoModificadorConsultaDTO>(this.grupoBasePath, data);
  }

  atualizarGrupo(id: number, data: GrupoModificadorDTO): Observable<GrupoModificadorConsultaDTO> {
    return this.apiService.update<GrupoModificadorConsultaDTO>(`${this.grupoBasePath}/${id}`, data);
  }

  removerGrupo(id: number): Observable<any> {
    return this.apiService.delete(`${this.grupoBasePath}/${id}`);
  }

  // --- Opcoes de Modificador ---

  listarOpcoes(grupoModificadorId: number): Observable<OpcaoModificadorConsultaDTO[]> {
    return this.apiService.read<OpcaoModificadorConsultaDTO[]>(
      `${this.opcaoBasePath}?grupoModificadorId=${grupoModificadorId}`
    );
  }

  buscarOpcaoPorId(id: number): Observable<OpcaoModificadorConsultaDTO> {
    return this.apiService.read<OpcaoModificadorConsultaDTO>(
      `${this.opcaoBasePath}/${id}`
    );
  }

  criarOpcao(data: OpcaoModificadorDTO): Observable<OpcaoModificadorConsultaDTO> {
    return this.apiService.create<OpcaoModificadorConsultaDTO>(this.opcaoBasePath, data);
  }

  atualizarOpcao(id: number, data: OpcaoModificadorDTO): Observable<OpcaoModificadorConsultaDTO> {
    return this.apiService.update<OpcaoModificadorConsultaDTO>(`${this.opcaoBasePath}/${id}`, data);
  }

  removerOpcao(id: number): Observable<any> {
    return this.apiService.delete(`${this.opcaoBasePath}/${id}`);
  }

  reordenarOpcoes(dto: ReordenarDTO): Observable<any> {
    return this.apiService.patch(`${this.opcaoBasePath}/reordenar`, dto);
  }
}
